import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Welcome } from "./Welcome";

function WelcomeContainerComponent({ adviser, name, firstLogin, lastLogin, newsItems }) {
    return (
        <Welcome
            adviser={adviser}
            firstLogin={firstLogin}
            lastLogin={lastLogin}
            newsItems={newsItems}
            name={name}
        />
    );
}

WelcomeContainerComponent.propTypes = {
    adviser: PropTypes.object,
    firstLogin: PropTypes.bool,
    lastLogin: PropTypes.string,
    newsItems: PropTypes.array,
    name: PropTypes.string
};

const mapStateToProps = state => ({
    adviser: state.adviser.adviser,
    firstLogin: state.applicationContext.firstLogin,
    lastLogin: state.user.lastLogin,
    newsItems: state.news.newsItems,
    name: state.user?.currentUser?.forename ?? ""
});

export const WelcomeContainer = connect(mapStateToProps)(WelcomeContainerComponent);
